import React from "react";
import {IIconGeneralPropsColor} from "modules/types";

export const IconClose: React.FC<IIconGeneralPropsColor> = ({
	width = 32,
	height = 32,
	color = "#FFFFFF",
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 32 32"
			fill="none">
			<path
				d="M25.3332 8.54667L23.4532 6.66667L15.9998 14.12L8.5465 6.66667L6.6665 8.54667L14.1198 16L6.6665 23.4533L8.5465 25.3333L15.9998 17.88L23.4532 25.3333L25.3332 23.4533L17.8798 16L25.3332 8.54667Z"
				fill={color}
			/>
		</svg>
	);
};
